var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54545 7.98046C6.54545 6.06984 7.07387 4.64094 7.94887 3.69877C8.81311 2.76818 10.1363 2.18181 12.0031 2.18181C13.8708 2.18181 15.1921 2.76702 16.0543 3.69552C16.9274 4.63568 17.4545 6.06279 17.4545 7.97444V10.9564H6.54545V7.98046ZM4.36364 10.9564V7.98046C4.36364 5.67966 5.00376 3.66379 6.35016 2.21404C7.70732 0.752701 9.65836 0 12.0031 0C14.3473 0 16.2971 0.750607 17.6531 2.21088C18.9984 3.6595 19.6364 5.67417 19.6364 7.97444V10.9564H21.8182C23.0232 10.9564 24 11.9333 24 13.1382V26.2292C24 27.4342 23.0232 28.411 21.8182 28.411H2.18182C0.976844 28.411 0 27.4342 0 26.2292V13.1382C0 11.9333 0.976844 10.9564 2.18182 10.9564H4.36364ZM2.18182 13.1382H21.8182V26.2292H2.18182V13.1382Z",
    fill: "#E5B80B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogImg3);
export default __webpack_public_path__ + "static/media/BlogImg3.74d1d549165fdc809bccb90126e5feff.svg";
export { ForwardRef as ReactComponent };